import PropTypes from "prop-types";
import Creature from "./Creature";

/** Ranked players with their creatures and scores. */
function Leaderboard({ rows, big = false }) {
  if (!rows.length) return null;
  return (
    <ol className="space-y-2" aria-label="Leaderboard">
      {rows.map((row) => (
        <li
          key={row.nickname}
          className="flex items-center gap-3 rounded-lg border bg-card px-3 py-2"
        >
          <span className={`w-8 shrink-0 font-semibold tabular-nums ${big ? "text-2xl" : "text-lg"}`}>
            {row.rank}
            <span className="sr-only">.</span>
          </span>{" "}
          <Creature kind={row.creature} size={big ? 48 : 36} />
          <span className={`min-w-0 flex-1 truncate font-medium ${big ? "text-2xl" : "text-base"}`}>
            {row.nickname}
          </span>{" "}
          <span className={`shrink-0 tabular-nums ${big ? "text-2xl" : "text-base"}`}>
            {row.score}
            <span className="sr-only"> points</span>
          </span>
        </li>
      ))}
    </ol>
  );
}

Leaderboard.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      rank: PropTypes.number.isRequired,
      nickname: PropTypes.string.isRequired,
      creature: PropTypes.number.isRequired,
      score: PropTypes.number.isRequired,
    }),
  ).isRequired,
  big: PropTypes.bool,
};

export default Leaderboard;
